import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { useOCRActivityLogs } from '@/service/gpu-instance/ocr-hook';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ActivityTable = () => {
  const { instanceId } = useParams<{ instanceId: string }>();
  const [page, setPage] = useState(1);
  const pageSize = 20;

  const { data, isLoading } = useOCRActivityLogs({
    instanceId: instanceId || '',
    page,
    pageSize,
  });

  const totalPages = data ? Math.ceil(data.total_count / pageSize) : 1;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Activity Logs</h3>
        <div className="text-sm text-muted-foreground">
          {data && `Showing ${data.logs.length} of ${data.total_count} entries`}
        </div>
      </div>

      {isLoading ? (
        <div className="flex h-[200px] items-center justify-center">
          <div className="text-muted-foreground">Loading activity logs...</div>
        </div>
      ) : (
        <>
          <DataTable columns={columns} data={data?.logs || []} />

          {/* Pagination */}
          <div className="flex items-center justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              <ChevronLeft className="h-4 w-4" />
              Previous
            </Button>
            <span className="text-sm text-muted-foreground">
              Page {page} of {totalPages}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              Next
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ActivityTable;
